var map = {
	"./CleverSaleVertical.svg": "944b",
	"./avatar-login.svg": "f774",
	"./bronze.svg": "a63e",
	"./calender_old.svg": "0e18",
	"./checkered_finish_flag.svg": "b9b5",
	"./close.svg": "1d1b",
	"./compartilhar.svg": "1e52",
	"./conquest.svg": "de6a",
	"./eraser.svg": "2dfb",
	"./exclamação-azul.svg": "aa4b",
	"./exclamação-roxo.svg": "81c7",
	"./filter.svg": "c86e",
	"./fist-flag.svg": "5bd1",
	"./flag.svg": "ec96",
	"./funil.svg": "987f",
	"./geral.svg": "de4c",
	"./gold.svg": "fdb1",
	"./icon-bell.svg": "a014",
	"./icon-blue-check.svg": "1439",
	"./icon-button-conversation.svg": "be67",
	"./icon-button-details.svg": "9cb9",
	"./icon-calendar-round-bg.svg": "fcd8",
	"./icon-cancel.svg": "dab7",
	"./icon-conversation.svg": "c0ec4",
	"./icon-csat-heart-round-bg.svg": "dc4c",
	"./icon-details.svg": "1672",
	"./icon-funnel.svg": "1c0b",
	"./icon-graphic-chart-round-bg.svg": "b935",
	"./icon-green-check.svg": "fa33",
	"./icon-grid.svg": "9fb4",
	"./icon-journey-call.svg": "29e6",
	"./icon-journey-csat.svg": "e788",
	"./icon-journey-proposal.svg": "4f8e",
	"./icon-journey-whatsapp.svg": "c590",
	"./icon-magnifying-glass.svg": "a8ce",
	"./icon-menu-dots.svg": "1de7",
	"./icon-menu-leads.svg": "cfca",
	"./icon-menu-result.svg": "7aa4",
	"./icon-message.svg": "b6ca",
	"./icon-money-round-bg.svg": "77a1",
	"./icon-money.svg": "25b8",
	"./icon-nps-heart.svg": "b191",
	"./icon-right-arrow.svg": "46f1",
	"./icon-send.svg": "28a4",
	"./icon-smartphone.svg": "7fdc",
	"./icon-star-rating-outline.svg": "0b87",
	"./icon-star-rating.svg": "bd00",
	"./icon-total-conversions-bg.svg": "ce46",
	"./icon-transhipment-chat.svg": "5f5f",
	"./icon-upload.svg": "9237",
	"./icon_campaign_loudspeaker.svg": "4ed0",
	"./icone-smartphone.svg": "ae30",
	"./left-arrow-2.svg": "07f5",
	"./left-arrow.svg": "f330",
	"./ligapontos-dir.svg": "f0af",
	"./ligapontos-esq.svg": "dea5",
	"./login_bg2.svg": "0989",
	"./logo-hero-cinza.svg": "14e4",
	"./logo-hero.svg": "4445",
	"./logo-weclever-dark.svg": "0ff5",
	"./logo-weclever-light.svg": "3319",
	"./logo.svg": "1ae4",
	"./nps.svg": "1d06",
	"./off-view.svg": "0b49",
	"./on-view.svg": "807e",
	"./parenteses.svg": "3dc3",
	"./pencil.svg": "2d07",
	"./platform-avatar1.svg": "a3bc",
	"./platform-avatar2.svg": "d394",
	"./platform-circulo.svg": "18d5",
	"./platform-quadrado.svg": "36b8",
	"./platform-seta-selec.svg": "5694",
	"./qr-code-frame.svg": "24c5",
	"./sentiment_negative.svg": "78e2",
	"./sentiment_negative_grey.svg": "43a0",
	"./sentiment_negative_white.svg": "87dc",
	"./sentiment_neutral.svg": "d166",
	"./sentiment_neutral_grey.svg": "0f0a",
	"./sentiment_neutral_white.svg": "f36d",
	"./sentiment_positive.svg": "6aed",
	"./sentiment_positive_grey.svg": "4334",
	"./sentiment_positive_white.svg": "847c",
	"./silver.svg": "941b",
	"./squad-white.svg": "789b",
	"./squad.svg": "cd90",
	"./start.svg": "cf11",
	"./to-conquer.svg": "ef44",
	"./tooltip-question-mark.svg": "f410",
	"./total_conversion_values.svg": "227a",
	"./total_conversions.svg": "ab6e",
	"./total_lead_scheduled.svg": "cbd9",
	"./total_leads.svg": "4e95",
	"./total_leads_contacted.svg": "21a0",
	"./total_leads_queue.svg": "b392",
	"./total_leads_valid.svg": "13d7",
	"./total_leads_worked.svg": "3ca3",
	"./upload.svg": "c93a",
	"./vertical.svg": "e214",
	"./view_off.svg": "f48e",
	"./view_on.svg": "89a7",
	"./webcam.svg": "25f3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f1df";